<template>
  <div class="signout">
    <h1>Déconnexion</h1>
    <br />
    <v-progress-circular 
      :size="70"
      :width="3"
      :color="$vuetify.theme.primary"
      indeterminate></v-progress-circular>

  </div>
</template>

<script>
export default {
  name: 'OidcSignout',
  mounted() {
    this.$router.push('/')
  }
}
</script>

<style scoped>
  .signout {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>